




























import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class Loading extends Vue
{
    @Prop({required: true}) text: string;

    @Prop({required: true}) error: boolean;

    get split()
    {
        return this.text.split('\n');
    }

    get message()
    {
        return this.error ? 'Error' : 'Loading';
    }
}
